import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const useNotificationMenuStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuPaper: {
      minWidth: 345,
      maxWidth: 345,
      border: `solid ${theme.palette.grey[800]} 1px`,
    },
    count: {
      position: "absolute",
      background: "red",
      top: -10,
      right: 1,
      width: 10,
      height: 10,
      // padding: "0.5px 3px",
      fontSize: 9,
      textAlign: "center",
      verticalAlign: "middle",
      borderRadius: "50%",
    },
    headerDiv: {
      display: "flex",
      padding: theme.spacing(0.5, 1, 0.5, 1),
      borderBottom: `solid ${theme.palette.grey[800]} 1px`,
    },
    headerText: { flexGrow: 1, color: "#eee", fontWeight: 540, fontSize: theme.typography.h6.fontSize },
    closeButton: { padding: 0, color: "#eee" },
    menuItem: {
      flexDirection: "column",
      cursor: "pointer",
      color: "white",
      fontSize: theme.typography.fontSize,
      padding: theme.spacing(1.5, 2, 1.5, 1),
      position: "relative",
      lineHeight: "100%",
      whiteSpace: "normal",
      "&:hover": {
        backgroundColor: "rgb(125 125 125 / 13%)",
      },
    },
    markHiddenBtn: { position: "absolute", top: 1, right: 0, color: "#eee", padding: 0 },
    notifAge: {
      fontSize: "0.7rem",
      color: theme.palette.grey[400],
      paddingLeft: 1,
      marginTop: 8,
    },
    notificationItemHeaderContainer: { display: "flex", alignItems: "center", marginBottom: 8 },
    commentText: {
      // marginTop: 4,
      // marginBottom: 4,
      overflow: "hidden",
      textOverflow: "clip",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      display: "-webkit-box",
    },
  })
);

export default useNotificationMenuStyles;
